import { useEffect, useState } from "react";
import { ArrowDown, ArrowUp } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { setBranch } from "@/lib/branch";
import { useSettings } from "@/context/SettingsContext";
import { MENUS } from "@/lib/menus";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Field } from "@/components/common";

const CABANG = ["admin_cabang", "kepala_bagian", "kasir", "petugas"];
const ORDERABLE = MENUS.filter((m) => m.key !== "dashboard" && m.roles.some((r) => CABANG.includes(r)));

const MenuOrder = ({ order, onChange }) => {
  const move = (i, d) => { const n = [...order]; [n[i], n[i + d]] = [n[i + d], n[i]]; onChange(n); };
  return (
    <div className="rounded-2xl border divide-y" data-testid="menu-order-list">
      {order.map((k, i) => {
        const m = ORDERABLE.find((x) => x.key === k);
        return (
          <div key={k} className="flex items-center gap-3 px-3 py-2" data-testid={`menu-order-${k}`}>
            <span className="w-6 text-xs font-mono text-muted-foreground">{i + 1}</span>
            <m.icon className="h-4 w-4 text-primary" />
            <span className="flex-1 text-sm font-medium">{m.label}</span>
            <Button size="sm" variant="ghost" className="h-8 w-8 p-0 rounded-full" disabled={i === 0} onClick={() => move(i, -1)} aria-label="Naik" data-testid={`menu-up-${k}`}><ArrowUp className="h-4 w-4" /></Button>
            <Button size="sm" variant="ghost" className="h-8 w-8 p-0 rounded-full" disabled={i === order.length - 1} onClick={() => move(i, 1)} aria-label="Turun" data-testid={`menu-down-${k}`}><ArrowDown className="h-4 w-4" /></Button>
          </div>
        );
      })}
    </div>
  );
};

export default function PengaturanCabangPage() {
  const { settings } = useSettings();
  const hidden = settings.hidden_menus || [];
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/cabang-settings").then((r) => {
      const saved = r.data.menu_order.filter((k) => ORDERABLE.some((m) => m.key === k));
      setF({ ...r.data, menu_order: [...saved, ...ORDERABLE.map((m) => m.key).filter((k) => !saved.includes(k))].filter((k) => !hidden.includes(k)) });
    }).catch((e) => toast.error(errMsg(e)));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const save = async () => {
    setBusy(true);
    try {
      const hiddenKeys = ORDERABLE.map((m) => m.key).filter((k) => hidden.includes(k));
      const { data } = await api.put("/cabang-settings", { ...f, menu_order: [...f.menu_order, ...hiddenKeys] });
      setBranch(data); toast.success("Pengaturan disimpan");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!f) return <p className="text-muted-foreground">Memuat...</p>;
  return (
    <div className="max-w-2xl space-y-6">
      <h1 className="font-heading text-2xl sm:text-3xl font-bold">Pengaturan Aplikasi</h1>
      <div className="panel space-y-4" data-testid="branch-receipt-settings">
        <p className="font-heading font-semibold">Cetak Struk</p>
        <Field label="Judul / Kop Struk" hint="Kosongkan untuk memakai nama aplikasi"><Input className="h-11" value={f.receipt_header} onChange={(e) => setF({ ...f, receipt_header: e.target.value })} data-testid="branch-receipt-header" /></Field>
        <Field label="Catatan Kaki Struk"><Textarea rows={3} value={f.receipt_footer} onChange={(e) => setF({ ...f, receipt_footer: e.target.value })} data-testid="branch-receipt-footer" /></Field>
      </div>
      <div className="panel space-y-4">
        <p className="font-heading font-semibold">Urutan Menu</p>
        <MenuOrder order={f.menu_order} onChange={(menu_order) => setF({ ...f, menu_order })} />
      </div>
      <Button className="h-11 rounded-full px-8" onClick={save} disabled={busy} data-testid="branch-settings-save">{busy ? "Menyimpan..." : "Simpan Pengaturan"}</Button>
    </div>
  );
}
